import axios from 'axios';
import { API, authHeaders } from './client';

export const getTestimonials = () =>
  axios.get(`${API}/testimonials`).then(r => r.data);

export const createTestimonial = (token, data) =>
  axios.post(`${API}/testimonials`, data, authHeaders(token)).then(r => r.data);

export const updateTestimonial = (token, id, data) =>
  axios.put(`${API}/testimonials/${id}`, data, authHeaders(token)).then(r => r.data);

export const deleteTestimonial = (token, id) =>
  axios.delete(`${API}/testimonials/${id}`, authHeaders(token)).then(r => r.data);
